import PageHero from '../../components/PageHero';
import { Link } from 'react-router-dom';
import './StaticPage.css';

function CookiePolicyPage() {
  return (
    <div className="static-page content-page">
      <PageHero
        title="Cookie Policy"
        subtitle="How we use cookies and similar technologies"
      />
      <div className="content-container">
        <p className="last-updated">Last updated: March 2025</p>
        <p>
          This Cookie Policy explains how WeddingzVenue uses cookies and similar technologies when you
          visit our website.
        </p>

        <h2>What are cookies?</h2>
        <p>
          Cookies are small text files stored on your device when you visit a website. They help the site
          remember your preferences, improve performance, and understand how you use the service.
        </p>

        <h2>Cookies we use</h2>
        <p>We use the following types of cookies:</p>
        <ul>
          <li><strong>Essential:</strong> Required for the website to function (e.g. login session, security).</li>
          <li><strong>Preferences:</strong> Remember your settings (e.g. language, region).</li>
          <li><strong>Analytics:</strong> Help us understand how visitors use our site so we can improve it.</li>
          <li><strong>Marketing:</strong> Used to deliver relevant ads (with your consent where required).</li>
        </ul>

        <h2>Managing cookies</h2>
        <p>
          You can control or delete cookies through your browser settings. Note that disabling certain
          cookies may affect the functionality of the website.
        </p>

        <h2>Third-party cookies</h2>
        <p>
          We may allow third-party services (e.g. analytics, social plugins) to set cookies. Their use
          is governed by their respective privacy policies.
        </p>

        <h2>Contact</h2>
        <p>
          For questions about this Cookie Policy, contact us at{' '}
          <a href="mailto:contact@weddingzvenue.in">contact@weddingzvenue.in</a> or visit our{' '}
          <Link to="/contact">Contact</Link> page.
        </p>
      </div>
    </div>
  );
}

export default CookiePolicyPage;
